export const mockCountryCodes = {
  AR: { country: 'AR', label: 'AR 54', value: '54', sites: ['ZPAR'] },
  AU: { country: 'AU', label: 'AU 61', value: '61', sites: [] },
  BO: { country: 'BO', label: 'BO 591', value: '591', sites: [] },
  BR: { country: 'BR', label: 'BR 55', value: '55', sites: ['IWBR', 'ICBR', 'WIBR', 'CMBR'] },
  BL: { country: 'BL', label: 'BL 32', value: '32', sites: [] },
  CH: { country: 'CH', label: 'CH 41', value: '41', sites: [] },
  CL: { country: 'CL', label: 'CL 56', value: '56', sites: [] },
  CO: { country: 'CO', label: 'CO 57', value: '57', sites: [] },
  DK: { country: 'DK', label: 'DK 45', value: '45', sites: [] },
  EC: { country: 'EC', label: 'EC 593', value: '593', sites: ['PLEC'] },
  EN: { country: 'EN', label: 'EN 44', value: '44', sites: [] },
  ES: { country: 'ES', label: 'ES 34', value: '34', sites: [] },
  FR: { country: 'FR', label: 'FR 33', value: '33', sites: [] },
  IT: { country: 'IT', label: 'IT 39', value: '39', sites: [] },
  JP: { country: 'JP', label: 'JP 81', value: '81', sites: [] },
  KR: { country: 'KR', label: 'KR 82', value: '82', sites: [] },
  MX: { country: 'MX', label: 'MX 52', value: '52', sites: ['24MX', 'VAMX'] },
  PA: { country: 'PA', label: 'PA 507', value: '507', sites: ['CAPA'] },
  PE: { country: 'PE', label: 'PE 51', value: '51', sites: ['DVPE', 'UBPE'] },
  PT: { country: 'PT', label: 'PT 351', value: '351', sites: [] },
  PY: { country: 'PY', label: 'PY 595', value: '595', sites: [] },
  SV: { country: 'SV', label: 'SV 503', value: '503', sites: ['CAPA'] },
  US: { country: 'US', label: 'US 1', value: '1', sites: [] },
  UY: { country: 'UY', label: 'UY 598', value: '598', sites: [] },
  VE: { country: 'VE', label: 'VE 58', value: '58', sites: ['LLVE'] }
};
